import { FormField, FormFieldset } from '@domgen/dgx-fe-forms/layout';

export interface CmsBillingAddressFieldset extends FormFieldset {
  billingAddressSameAsAddressField: FormField;
}
